// src/pages/Admin/TeacherSalas/Page_Teacher_evalucacion.jsx
import React, { useState, useEffect } from "react";
import { useAuth } from "../../../../hooks";
import { Loader } from "semantic-ui-react";
import { TeacherAPI } from "../../../../api";
import "./Page_Teacher_evalucacion.scss";

// Importamos nuestro nuevo grid
import { TeacherEvaluationGrid } from "../../../../components/Admin/EvaluationRutasComp/TeacherEvaluationGrid";

const teacherController = new TeacherAPI();

export function Page_Teacher_evalucacion() {
  const { user, accessToken } = useAuth();
  const [teacher, setTeacher] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTeacherData = async () => {
      try {
        const response = await teacherController.getTeacherById(
          accessToken,
          user?.user?.teacher
        );
        setTeacher(response.teacher);
      } catch (error) {
        console.error("Error al obtener datos del docente:", error);
      } finally {
        setLoading(false);
      }
    };

    if (user?.user?.teacher) {
      fetchTeacherData();
    }
  }, [accessToken, user]);

  if (loading) {
    return (
      <Loader active inline="centered">
        Cargando datos del docente...
      </Loader>
    );
  }

  if (!teacher) {
    return ;
  }

  return (
    <div className="page-teacher-evaluacion">
      {/* Separator antes del grid */}
      <hr className="intro-divider" />

      <TeacherEvaluationGrid
        teacher={teacher}
        accessToken={accessToken}
      />
    </div>
  );
}
